export const ONE_LINK_URL = ''
export const FALLBACK_URL = ''

export const COOLDOWN_COOKIE_NAME = 'mt_app_suggestion_cooldown'

export const COOLDOWN_HOURS = {
  DEFAULT: 24,
  AFTER_INSTALL_CLICK: 48
}

export const CAMPAIGN_SUFFIX = 'suggestion-drawer'
